/** Etiqueta canónica de propina en comprobante fiscal impreso / PDF. */
export const FISCAL_TIP_LINE_LABEL = 'Propina';

export type FiscalLineWithQtyPrice = {
  label: string;
  quantity: number;
  price: number;
  sku?: string | null;
  unitOfMeasure?: string | null;
};

/** Agrega línea 1× propina cuando el cobro la incluyó (mercadería va en `items`). */
export function withFiscalTipLine<T extends FiscalLineWithQtyPrice>(
  items: T[],
  tipAmount: number
): T[] {
  const tip = Math.round(Number(tipAmount) * 100) / 100;
  if (!Number.isFinite(tip) || tip <= 0) return items;
  return [
    ...items,
    {
      label: FISCAL_TIP_LINE_LABEL,
      quantity: 1,
      price: tip,
    } as T,
  ];
}
